<template>
  <div class="name-page">
    <div class="name-modal">
      <div class="name-project">{{ 'Enter your email for join to call' | i18n }}</div>

      <Input
        v-model="email"
        form-group-id="email"
        placeholder="email"
        autocomplete="off"
        type="email"
        :update-error="updateError"
        :disabled="loading"
        :onChange="enterEmail"
      />
      <Input v-model="password" v-if="showPassword" form-group-id="Password" placeholder="Password" :disabled="loading" type="password" />

      <span v-if="loading" class="loader-box">
        <Loader />
      </span>
      <span v-else class="submit-button">
        <b-button size="sm" variant="primary" :disabled="!email || inputError" @click="authorizeUser">{{ 'Join' | i18n }}</b-button>
        <span v-if="status === 'Declined'" style="margin-top: 5px">{{ 'Your join request was canceled' | i18n }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import jwt from 'jsonwebtoken';

import Input from '../../../../common/input';
import Loader from '../../../../common/loader';
import { WS_TYPES, SUPPORTED_LANGUAGES } from '../../../../../../../../../constants';

import { AuthMixin, FirebaseMixinOne, NotificationMixin } from '../../../../../../mixins';

export default {
  name: 'UserName',
  mixins: [AuthMixin, FirebaseMixinOne, NotificationMixin],
  components: {
    Input,
    Loader,
  },
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      status: false,
      showPassword: false,
      isConnected: false,
      inputError: false,
      connection: null,
    };
  },
  props: {
    project: {
      type: Object,
      default: () => {},
    },
    setUserName: {
      type: Function,
      default: () => {},
    },
  },
  beforeDestroy() {
    if (this.connection) {
      this.connection.close();
    }
  },
  methods: {
    updateError(e) {
      this.inputError = e;
    },
    enterEmail() {
      this.password = '';
      this.status = false;
      this.showPassword = false;
    },
    async login() {
      try {
        const auth = await this.authService.signIn({
          email: this.email,
          password: this.password,
        });

        if (auth.firebase) {
          await this.firebaseServiceOne.signIn(auth.firebase.token, this.email);
        }
        const decodedAuth = jwt.decode(auth.access_token);

        const localLanguage = localStorage.getItem('lng');

        const newLanguage = decodedAuth.language || (localLanguage ? JSON.parse(localLanguage).toUpperCase() : 'EN');

        this.setAuth({
          ...auth,
          role: decodedAuth.role,
          email: decodedAuth.email,
          username: decodedAuth.username,
          language: newLanguage,
        });
        if (SUPPORTED_LANGUAGES.includes(newLanguage.toLowerCase())) {
          this.$changeLanguage(newLanguage.toLowerCase());
        }

        window.location.reload(false);
      } catch (err) {
        this.showNotification({
          type: 'error',
          title: this.$translate('sign_in'),
          message: err.message,
        });
      }
    },
    async authorizeUser() {
      this.status = false;

      if (this.showPassword) {
        return this.login();
      }
      this.loading = true;

      if (this.connection) {
        this.connection.close();
      }
      const base = axios.defaults.baseURL.replace('http://', '').replace('https://', '');
      const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
      const connection = new WebSocket(`${wsProtocol}://${base}/live?email=${this.email}&project=${this.$route.params.id}`);
      this.connection = connection;
      connection.onopen = () => {
        this.isConnected = true;
        this.connection.send(
          JSON.stringify({
            type: WS_TYPES.REQUEST_AUTHORIZATION,
            id: this.$route.params.id,
            email: this.email,
          })
        );
      };
      connection.onerror = (error) => {
        console.log(error, 'error');
      };

      // connection.onclose = (m) => {
      //   console.log('clsoe');
      //   this.isConnected = false;
      //   setTimeout(() => {
      //     this.connectToServer();
      //   }, 1000);
      // };

      connection.onmessage = (message) => {
        try {
          const data = JSON.parse(message.data);
          console.log(data, 'data');
          if (data && data.type === WS_TYPES.DECLINE_AUTHORIZATION) {
            this.loading = false;
            this.status = 'Declined';
            return;
          }
          if (data && data.type === WS_TYPES.ACCEPT_AUTHORIZATION) {
            this.password = data.password;
            this.login();
            return;
          }
          if (data && data.type === WS_TYPES.USER_EXIST) {
            this.loading = false;
            this.showPassword = true;
            return;
          }
        } catch (e) {
          console.log(e, 'e');
        }
      };
    },
  },
};
</script>

<style lang="scss">
.name-page {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.name-modal {
  max-width: 100%;
  width: 400px;
  // height: 400px;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 6px;
  padding: 50px;
  position: relative;
  justify-content: center;
}

.name-project {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}

.submit-button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.loader-box {
  transform: scale(0.5);
  height: 49px;
  margin-top: -35px;
}
</style>
